<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a>This book was published with the support of<br/>the Braun Chair Research Fund, established through the generosity<br/>of Mr. Lawrence E. Glick and Mrs. Nancy S. Glick.</p>
<p class="copyrighta"><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/>www.nyupress.org</p>
<p class="copyright1">© 2010 by New York University<br/>All rights reserved</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data<br/>Jews and the Civil War : a reader /<br/>Edited by Jonathan D. Sarna and Adam Mendelsohn.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978–0–8147–4091–0 (cl : alk. paper)<br/>ISBN-10: 0–8147–4091–X (cl : alk. paper)<br/>1. United States—History—Civil War, 1861–1865—Social aspects.<br/>2. United States—History—Civil War, 1861–1865—Jews. 3. United<br/>States—History—Civil War, 1861–1865—Participation, Jewish. 4. United<br/>States—Ethnic relations—History—18th century. 5. United States—Ethnic<br/>relations—History—19th century. 6. Slavery—United States—History. 7.<br/>African Americans—Relations with Jews—History—19th century.<br/>8. Jews—United States—History—19th century. I. Sarna, Jonathan D.<br/>II. Mendelsohn, Adam D., 1979–<br/>E468.9.J49      2010<br/>973.7’08924—dc22 2009050086</p>
<p class="copyright1">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.<br/>We strive to use environmentally responsible suppliers and materials<br/>to the greatest extent possible in publishing our books.</p>
<p class="copyright1">Manufactured in the United States of America</p>
<p class="copyright1">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?105f4402